import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  DescriptionStyles,
  PageStyles,
  TitleStyles,
} from './LonelinessGraph.styles';

export const ScreenLonelinessGraph: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Loneliness Graph',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  return (
    <PageStyles>
      <IonContent>
        <TitleStyles>
          Feeling lonely is okay. Even if you are in the relationship
        </TitleStyles>

        <div className="img-container">
          <img src="" alt="preferences_image" />
        </div>

        <DescriptionStyles>
          <UiTypography variant="title-medium" color="black">
            Odds of Premature Mortality
          </UiTypography>
          <UiTypography variant="label-small" color="neutral-black">
            Source: Holt-Lunstad J, Robles TF, Sbarra DA. <br />
            Advancing Social Connection as a
          </UiTypography>
        </DescriptionStyles>
      </IonContent>

      <OnboardingFooter onContinue={wizard.nextStep} />
    </PageStyles>
  );
};
